module.exports = __webpack_public_path__ + "img/pattern.7baf7020.svg";